import { Layout } from '@taxdown/piccolo-web';
import OneColLayout from 'Components/Layouts/OneColLayout';
import * as Styled from './styles';
import EfirmaForm from './components/EFirmaForm';

const DataGatheringAccessEfirma = (): JSX.Element => (
  <OneColLayout>
    <Layout.Grid
      alignContent="flex-start"
      alignItems="flex-start"
      columns="repeat(1, 1fr)"
      gap="dimension_08"
      justifyContent="center"
      justifyItems="center"
    >
      <Styled.ContentContainer>
        <EfirmaForm />
      </Styled.ContentContainer>
    </Layout.Grid>
  </OneColLayout>
);

export default DataGatheringAccessEfirma;
